// index.ts
import { installExtension } from "@juitnow/lib-fetch-client";
var RecaptchaImpl = class {
  constructor(_http) {
    this._http = _http;
  }
  _path = "/recaptcha/v1";
  async verify(token) {
    const response = await this._http.post(`${this._path}`, { token }, { headers: { "Content-Type": "application/json" } });
    return response.data;
  }
};
installExtension("recaptcha", RecaptchaImpl);
//# sourceMappingURL=index.mjs.map
